import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function HaulageShipping() {
  return (
    <>
      <SEO
        title="Fastlane ApS :: Haulage and Shipping"
        description="Global transport of goods by ship (container), aeroplane, train or truck. Professional single point for outsourcing shipping, haulage and logistics."
        canonicalUrl="https://fastlane.dk/haulage-and-shipping"
      />

      <PageHeader
        title="Haulage and Shipping"
        subtitle="Global transport of goods by ship (container), aeroplane, train or truck."
        breadcrumbs={[
          { label: 'Services', path: '/godstransport-i-europa' },
          { label: 'Haulage and Shipping' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <div className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg">
            <p>
              Global transport of goods by ship (container), aeroplane, train or truck.
            </p>
            <p>
              Enthusiastic and professional single point for outsourcing shipping, haulage and logistics. We listen &ldquo;loud&rdquo; and develop the right solutions keeping our clients demands and interests in focus.
            </p>
          </div>

          <div className="bg-slate-50 p-6 sm:p-8 rounded-2xl border border-slate-200">
            <h2 className="text-xl font-bold text-[#0f2b48] mb-4">Our Commitment:</h2>
            <ul className="space-y-2.5 text-sm sm:text-base text-slate-800">
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>Right solution</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>Goods on time</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>Low freight rates</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>Right sequence or processes and precise communication</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>In short the right <strong className="text-[#0f2b48]">quality</strong></span>
              </li>
            </ul>
          </div>

          {/* Niches */}
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-[#0f2b48]">We service the following niches:</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-slate-800">
              {[
                { label: 'UK to/from Scandinavia', path: '/gateway-tofrom-ukscandinavia' },
                { label: "Dangerous goods transport (in house software for issuing DGN's and IMDG's)", path: '/adr-gods' },
                { label: 'Approved for food transport by the Danish Veterinary and Food Administration' },
                { label: 'Warehousing (also bonded)', path: '/lager' },
                { label: 'Transport insurance', path: '/forsikring' },
                { label: 'Export and import documentation', path: '/import' },
                { label: 'Project transport' },
                { label: 'Art transport' },
                { label: 'Transport of Exhibition Goods' }
              ].map((niche, idx) => (
                <div key={idx} className="p-4 rounded-xl border border-slate-200 bg-white shadow-2xs flex items-center justify-between">
                  <div className="flex items-start gap-2.5">
                    <i className="fa-solid fa-shield-halved text-sky-700 mt-1 shrink-0 text-xs" aria-hidden="true" />
                    <span className="font-semibold text-slate-900">{niche.label}</span>
                  </div>
                  {niche.path && (
                    <Link to={niche.path} className="text-sky-700 hover:text-sky-900 text-xs shrink-0 ml-2" aria-label={`Read more about ${niche.label}`}>
                      <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-center sm:justify-between border-t border-slate-200">
            <span className="text-sm text-slate-600">Need haulage and shipping advice?</span>
            <Link
              to="/fragtrater"
              className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-[#b25d19] text-white text-sm font-semibold hover:bg-[#974d12] text-center"
            >
              Get a freight rate
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
